import { ServicesContainer } from '@/services';
import { ApiErrorEvent } from '@/services/analytics/events';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AnalyticsError, AnalyticsEventType, WebInteraction } from '../models';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeApiErrorEvent extends AdobeBaseEvent{
    event = AnalyticsEventType.Error;
    error = { errors: { value: 1 } } as AnalyticsError;
  
    constructor(event: ApiErrorEvent, store: Store<AppState>, services: ServicesContainer) {
      super(store, services);
      this.web.webInteraction = {
        name: event?.operationName,
        linkClicks: { value: 1 },
        type: 'other',
      }
    
      const apiError = event?.apiErrors[0];
      this.error.errorName = `apiError|${apiError?.errorDescription ?? ''}`;
      this.error.errorCode = apiError?.errorCode;
      this.error.serviceName = event?.serviceName;
      this.error.internalErrorName = event?.operationName;
    }
  }